var map = {
	"./account-circle.svg": 10189,
	"./account.svg": 82808,
	"./arrow-circle.svg": 75690,
	"./arrow.svg": 94256,
	"./basket.svg": 79918,
	"./burger.svg": 75909,
	"./certificates.svg": 26433,
	"./check.svg": 81856,
	"./checked.svg": 62093,
	"./close.svg": 62591,
	"./configeditor.svg": 55794,
	"./dns.svg": 49540,
	"./download.svg": 23796,
	"./edit.svg": 98978,
	"./editor.svg": 82363,
	"./eye.svg": 2832,
	"./eye_closed.svg": 17658,
	"./info.svg": 81399,
	"./information-outline.svg": 50770,
	"./keyboard_arrow_left.svg": 56754,
	"./lang.svg": 83072,
	"./list.svg": 57400,
	"./lock.svg": 91110,
	"./log.svg": 69297,
	"./logging.svg": 15950,
	"./logo.svg": 44386,
	"./luaeditor.svg": 75063,
	"./menu.svg": 33019,
	"./mqtt.svg": 68108,
	"./network.svg": 15733,
	"./ntp.svg": 90979,
	"./partitions.svg": 37169,
	"./plus.svg": 40324,
	"./reboot.svg": 70048,
	"./save.svg": 86720,
	"./script-text.svg": 44787,
	"./smtp.svg": 2392,
	"./snmp.svg": 14775,
	"./success.svg": 85780,
	"./syslog.svg": 47453,
	"./system.svg": 38286,
	"./systeminfo.svg": 83935,
	"./translate.svg": 49847,
	"./update.svg": 92342,
	"./upload.svg": 74022,
	"./users.svg": 80863,
	"./webserver.svg": 86410,
	"./wifi.svg": 52471
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87254;